import React, { Component } from "react";
import BenefitsList from "../component/BenefitsList";

export default class Benefits extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="right_side_wrapper">
          <BenefitsList />
        </div>
      </React.Fragment>
    );
  }
}
